export const makeRelativeIfNeeded = (path: string): string => {
  return path?.startsWith('.') ? path : `.${path}`;
};
